import {RingProgress} from '@mantine/core';
import type React from 'react';
import {MdClose} from 'react-icons/md';
import {COLOR_PRIMARY} from '../../../../../../config/constants/colorCodes';
import {PROFILE_BASE} from '../../../../../../config/constants/routes';
import {CommonLink} from '../../../../../../shared/components/CommonLink';
import {getCompletionMessage} from './utils';

export type ProfileCompletionIndicatorProps = {
  inputRate: number;
  firstUnfilledFieldLabel: string;
  requiredAction: string;
  onClose: () => void;
};

export const ProfileCompletionIndicator: React.FC<
  ProfileCompletionIndicatorProps
> = ({inputRate, firstUnfilledFieldLabel, requiredAction, onClose}) => {
  const message = getCompletionMessage(firstUnfilledFieldLabel, requiredAction);

  return (
    <div className="flex bg-background-1 p-4 rounded-16 items-center justify-between">
      <div className="flex items-center gap-8">
        <RingProgress
          size={60}
          thickness={4}
          label={
            <div className="font-bold text-center text-primary text-sm pc:text-base">
              {`${inputRate}%`}
            </div>
          }
          sections={[
            {
              value: inputRate,
              color: COLOR_PRIMARY,
            },
          ]}
        />
        <div className="text-base">{message}</div>
      </div>
      <div className="flex items-center gap-16">
        <CommonLink
          href={PROFILE_BASE}
          className="hidden pc:block text-sm text-primary p-16 pc:py-8 px-16 border border-primary rounded-12 cursor-pointer hover:opacity-60"
        >
          プロフィール編集
        </CommonLink>
        <div className="flex items-start p-4">
          <button
            type="button"
            onClick={onClose}
            className="flex bg-black-4 p-[2px] hover:opacity-60 rounded-full transition-colors flex-shrink-0"
            aria-label="閉じる"
          >
            <MdClose size={12} />
          </button>
        </div>
      </div>
    </div>
  );
};
